<footer class="Footer">
    <div class="uk-container">
        <section class="Footer_Nav" *ngIf="sectionService.sections.length > 0">
			<div *ngFor="let category of sectionService.sections" class="FooterNav uk-grid" uk-grid>
			    <div class="uk-width-2-2 uk-width-1-4@m uk-width-1-5@l uk-first-column">
			        <h3>{{ category.NAME }}</h3>
			    </div>

			    <div class="uk-width-1-1 uk-width-3-4@m uk-width-4-5@l uk-grid-margin uk-first-column">
			        <ul class="FooterNav_List" *ngIf="category.SUBSECTIONS.length > 0">
			            <li *ngFor="let section of category.SUBSECTIONS" class="FooterNav_List_Item">
							<a [routerLink]="['/catalog/section/', section.CODE || section.ID]">{{ section.NAME }}</a>
						</li>
			        </ul>
			    </div>
			</div>
        </section>

        <section class="Footer_Contacts uk-grid" uk-grid>
            <div class="uk-width-2-2 uk-flex uk-flex-middle uk-width-1-4@m uk-width-1-5@l uk-first-column">
                <div class="uk-display-inline-block">
                    <div class="Footer_Contacts_Phone">
						<a class="Footer_Contacts_PhoneNumber" href="tel:88007757399">8-800-775-73-99</a>
						<div class="Footer_Contacts_PhoneCity" *ngIf="cityService.city.PROPERTY_INFLECTED_VALUE!== 'России'">
							<span>Телефон в {{cityService.city.PROPERTY_INFLECTED_VALUE}}</span>
						</div>
						<div class="Footer_Contacts_PhoneCity" *ngIf="cityService.PROPERTY_INFLECTED_VALUE=== 'России'" >
							<span class="Footer_Contacts_SubPhone">Телефон в Самаре</span>
						</div>
					</div>

                    <!-- <div class="Footer_Contacts_Phone">
						<a class="Footer_Contacts_PhoneNumber" href="tel:88005553535">8 800 555 35 35</a>
						<span class="Footer_Contacts_SubPhone">Горячая линия</span>
					</div> -->
                </div>
            </div>

            <div class="Footer_Contacts_Btns uk-width-1-1 uk-width-3-4@m uk-width-4-5@l uk-gris-margin uk-first-column">
				<a class="FooterBtn uk-button" href="tel:88007757399">
					<span>Позвонить нам Онлайн</span>
					<span class="IconItem IconItem--phone">
						<img src="/assets/img/icon/phone.svg" uk-svg>
					</span>
				</a>

				<a class="FooterBtn uk-button" href="https://get.teamviewer.com/helpzolotoykod" target="_blank">
					<span>Скачать программу</span>
					<span class="uk-visible@s">&nbsp;для помощи</span>
					<span class="IconItem IconItem--download">
						<img src="/assets/img/icon/download.svg" uk-svg>
					</span>
				</a>

                <!-- <button class="FooterBtn uk-button" type="button">
					<span>Сказать спасибо</span>
					<span class="IconItem IconItem--thanks">
						<img src="/assets/img/icon/thanks.svg" uk-svg>
					</span>
				</button> -->
            </div>
        </section>
    </div>
</footer>

<section class="Copyright">
	<div class="uk-container uk-container_2">
		<a href="https://vk.com/zolotoykod" target="_blank"><img src="assets\img\icon-footer\1-vk.svg" width="40" height="40" alt=""></a>
		<a href="https://www.instagram.com/zolotoy_kod/" target="_blank"><img src="assets\img\icon-footer\1-insta.svg" width="40" height="40" alt=""></a>
		<a href="https://www.youtube.com/user/zolotoykodhoreca" target="_blank"><img src="assets\img\icon-footer\1-youtube.svg" width="40" height="40" alt=""></a>
	</div>
    <div class="uk-container uk-container_1">
        <div class="uk-display-inline-block">
			<div *ngIf="cityService.city.PROPERTY_ADDRESS_VALUE!== null">
				<div [innerHTML]=cityService.city.PROPERTY_ADDRESS_VALUE></div>
			</div>
			<div *ngIf="cityService.city.PROPERTY_ADDRESS_VALUE === null">
				<div> Адрес: г. Самара, ул. Лесная, 23, корпус 100, офис 329</div>
			</div>

			<div *ngIf="cityService.city.PROPERTY_EMAIL_VALUE!== null">
				<a [innerHTML]=cityService.city.PROPERTY_EMAIL_VALUE href="mailto:{{ cityService.city.PROPERTY_EMAIL_VALUE}}"></a>
			</div>

			<div *ngIf="cityService.city.PROPERTY_EMAIL_VALUE === null">
			   <div>E-mail:<a href="mailto:info@zolotoykod.ru">info@zolotoykod.ru</a></div>
			</div>
        </div>
        <div class="uk-text-right uk-float-right uk-visible@m">
            <div>2020, Золотой Код<span class="uk-visible@l"> - ИТ-Проекты любой сложности.</span></div>
            <div>Разработка - Внедрение - Поддержка</div>
		</div>
</div>
</section>


